import * as types from '../constants/ui';

export const TheBehaviorDrawer = payload => dispatch => {
  dispatch({
    type: types.SIDENAV,
    payload,
  });
};

export const profileNav = payload => dispatch =>
  dispatch({
    type: types.PROFILE_NAV,
    payload,
  });

export const FilterBehavior = payload => dispatch => {
  dispatch({
    type: types.FILTER,
    payload,
  });
};

export const reusableModal = payload => dispatch => {
  dispatch({
    type: types.MODAL,
    payload: {},
  });
  dispatch({
    type: types.MODAL,
    payload,
  });
};
